import { render, staticRenderFns } from "./UserQueries.vue?vue&type=template&id=624c9d23&"
import script from "./UserQueries.vue?vue&type=script&lang=js&"
export * from "./UserQueries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports